import { Link } from 'react-router-dom';
import { MapPin, Mail } from 'lucide-react';

const LOGO = '/assets/logo_transparente.png';

// NAP Data - Editable placeholders
const NAP = {
  name: 'REALimenta',
  location: 'Málaga, Andalucía, España',
  email: 'realimenta.naturalvet@gmail.com',
};

const footerLinks = {
  servicios: [
    { href: '/servicios', label: 'Consulta inicial' },
    { href: '/servicios', label: 'Seguimiento' },
    { href: '/como-funciona', label: 'Cómo funciona' },
  ],
  informacion: [
    { href: '/sobre-realimenta', label: 'Sobre REALimenta' },
    { href: '/#faq', label: 'Preguntas frecuentes', isAnchor: true },
    { href: '/contacto', label: 'Contacto' },
  ],
  legal: [
    { href: '/aviso-legal', label: 'Aviso legal' },
    { href: '/privacidad', label: 'Política de privacidad' },
    { href: '/politica-cookies', label: 'Política de cookies' },
  ],
};

export const Footer = () => {
  return (
    <footer className="bg-brand-primary text-white" data-testid="main-footer">
      <div className="section-container py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6" data-testid="footer-logo">
              <img src={LOGO} alt="REALimenta" className="w-14 h-14" />
              <span className="font-manrope font-bold text-xl">REALimenta</span>
            </Link>
            <p className="text-white/80 text-sm mb-4">
              Nutrición veterinaria online para perros y gatos
            </p>
            <p className="text-brand-light-yellow font-medium text-sm">
              Base en Málaga · Atención online en toda España
            </p>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="font-manrope font-bold text-lg mb-4">Servicios</h4>
            <ul className="space-y-3">
              {footerLinks.servicios.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-white/80 hover:text-brand-secondary transition-colors text-sm"
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Information Links */}
          <div>
            <h4 className="font-manrope font-bold text-lg mb-4">Información</h4>
            <ul className="space-y-3">
              {footerLinks.informacion.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-white/80 hover:text-brand-secondary transition-colors text-sm"
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact / NAP */}
          <div>
            <h4 className="font-manrope font-bold text-lg mb-4">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-brand-secondary flex-shrink-0 mt-0.5" />
                <span className="text-white/80 text-sm">{NAP.location}</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-brand-secondary flex-shrink-0 mt-0.5" />
                <a
                  href={`mailto:${NAP.email}`}
                  className="text-white/80 hover:text-brand-secondary transition-colors text-sm"
                  data-testid="footer-email"
                >
                  {NAP.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            {/* Legal Links */}
            <div className="flex flex-wrap justify-center gap-6">
              {footerLinks.legal.map((link) => (
                <Link
                  key={link.label}
                  to={link.href}
                  className="text-white/60 hover:text-white transition-colors text-sm"
                  data-testid={`footer-legal-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                >
                  {link.label}
                </Link>
              ))}
            </div>

            {/* Copyright */}
            <p className="text-white/60 text-sm text-center">
              © {new Date().getFullYear()} {NAP.name}. Todos los derechos reservados.
            </p>
          </div>

          {/* Disclaimer */}
          <p className="text-white/50 text-xs text-center mt-6 max-w-3xl mx-auto">
            La información de esta web no sustituye una consulta veterinaria presencial cuando sea necesaria. 
            Cada caso es único y requiere valoración personalizada.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
